module.exports = __webpack_public_path__ + "static/p-meifaisal-52b365ead4c3cde235cce13fe77b0027.png";